// ** Logo
import logo from 'assets/media/Logo.png'
import './style.scss'
import { useTranslation } from 'react-i18next'

const FallbackSpinner = ({
  message
}) => {

  const { t } = useTranslation()

  return (
    <div className='fallback-spinner app-loader'>
      <img className='fallback-logo' src={logo} alt='' width={250} height={120}/>
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
      <h4 className='FallbackSpinner_message_m17'>{t(message)}</h4>
    </div>
  )
}

export default FallbackSpinner
